export const buttonTransitionStyle = 'all 0.05s ease-out';
